import { Link } from 'react-router-dom';
import { popularComics } from '@/mocks/homeData';

export default function PopularRanking() {
  return (
    <section className="py-16 md:py-24 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        {/* Header */}
        <div className="mb-12">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-3">
            本周人气榜
          </h2>
          <p className="text-foreground-600 text-base">
            最受欢迎的韩国漫画，数据实时更新
          </p>
        </div>

        {/* Ranking Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {popularComics.map((comic) => (
            <div
              key={comic.id}
              className="group rounded-2xl bg-background-50 border border-background-200/70 overflow-hidden hover:border-accent-300 transition-all duration-300"
              data-product-shop
            >
              {/* Cover */}
              <div className="relative aspect-[3/4] overflow-hidden">
                <img
                  src={comic.cover}
                  alt={comic.title}
                  title={`${comic.title} - 韩国漫画在线观看`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                {/* Rank badge */}
                <div className="absolute top-3 left-3 w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                  <span className="font-heading text-sm font-bold text-background-50">{comic.rank}</span>
                </div>
                {/* Rating */}
                <div className="absolute top-3 right-3 px-2.5 py-1 rounded-full bg-foreground-950/70 backdrop-blur-sm flex items-center gap-1">
                  <i className="ri-star-fill text-amber-400 text-xs"></i>
                  <span className="text-xs font-semibold text-background-50">{comic.rating}</span>
                </div>
              </div>

              {/* Info */}
              <div className="p-5">
                <h3 className="font-heading text-lg font-bold text-foreground-900 mb-2">
                  <Link to="/category/all" className="hover:text-primary-600 transition-colors cursor-pointer">
                    {comic.title}
                  </Link>
                </h3>

                {/* Tags */}
                <div className="flex flex-wrap gap-2 mb-3">
                  {comic.tags.map((tag) => (
                    <span
                      key={tag}
                      className="px-2.5 py-0.5 rounded-md bg-secondary-100 text-secondary-700 text-xs font-medium"
                    >
                      {tag}
                    </span>
                  ))}
                </div>

                {/* Meta */}
                <div className="flex items-center justify-between text-xs text-foreground-500 mb-4">
                  <span><i className="ri-eye-line mr-1"></i>{comic.views}</span>
                  <span>{comic.updateTime}</span>
                </div>

                {/* Button */}
                <Link
                  to="/category/all"
                  className={`block w-full py-2.5 rounded-full text-center text-sm font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer ${
                    comic.rank === 1
                      ? 'bg-primary-500 text-background-50 hover:bg-primary-600'
                      : 'bg-background-100 text-foreground-800 border border-background-300 hover:bg-background-200'
                  }`}
                >
                  开始阅读
                </Link>
                <p className="text-center text-xs text-foreground-500 mt-2">
                  已更新至 {comic.latestChapter}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}